import { createSlice } from '@reduxjs/toolkit'

export const CourseProgressStatus = Object.freeze({
    Loading: 'loading',
    Success: 'success',
    Failure: 'failure',
})

const initialState = {
    status: null,
    errorMessage: '',
    courseProgress: [],
    completionPercentage: 0,
}

const courseProgressSlice = createSlice({
    name: 'courseProgress',
    initialState,
    reducers: {
        getCourseProgressRequest(state) {
            state.status = CourseProgressStatus.Loading
            state.errorMessage = ''
        },
        getCourseProgressRequestSuccess(state, action) {
            state.status = CourseProgressStatus.Success
            state.courseProgress = action.payload.items
            state.completionPercentage = action.payload.percentageCompleted
        },
        getCourseProgressRequestFailure(state, action) {
            state.status = CourseProgressStatus.Failure
            state.errorMessage = action.payload
        },
        setCurrentTopic(state, action) {
            const topic = state.courseProgress.find(
                p => `${p.topicId}` === `${action.payload}`
            )
            topic.current = true
        },
        markTopicDone(state, action) {
            const topic = state.courseProgress.find(
                p => `${p.topicId}` === `${action.payload}`
            )
            topic.completed = true
        },
    },
})

const {
    getCourseProgressRequest,
    getCourseProgressRequestSuccess,
    getCourseProgressRequestFailure,
    setCurrentTopic,
    markTopicDone,
} = courseProgressSlice.actions

export const courseProgressActions = {
    getCourseProgressRequest,
    getCourseProgressRequestSuccess,
    getCourseProgressRequestFailure,
    setCurrentTopic,
    markTopicDone,
}

const s = state => state.courseProgress

export const courseProgressSelectors = {
    isFetching(state) {
        return s(state).status === CourseProgressStatus.Loading
    },
    hasError(state) {
        return s(state).status === CourseProgressStatus.Failure
    },
    errorMessage(state) {
        return s(state).errorMessage
    },
    courseProgress(state) {
        return s(state).courseProgress
    },
}

const courseProgressReducer = courseProgressSlice.reducer

export default courseProgressReducer
